import React from 'react';
import { usePageTitle } from '../hooks/usePageTitle';
import NotImplemented from '../components/NotImplemented';

export default function TestExecution() {
	usePageTitle('sitio.enConstruccion');

	return (
		<NotImplemented></NotImplemented>
	);
}
